import React from 'react';
import { AlertTriangle, Send } from 'lucide-react';
import { Button } from '@easyflow/ui-frontend/components/ui/button';
import type { ArtifactViewerProps } from '../types';
import type { ActionContent } from './shared';

export const ActionViewer: React.FC<ArtifactViewerProps> = ({ artifact, onAction }) => {
  const c = artifact.content as Partial<ActionContent>;
  const intent = typeof c?.intent === 'string' ? c.intent : 'unknown';
  const description = typeof c?.description === 'string' ? c.description : 'Azione proposta dall\'assistente';
  const cta = typeof c?.cta === 'string' ? c.cta : 'Esegui';
  const destructive = c?.destructive === true;
  return (
    <div className={`p-4 rounded-lg border ${destructive ? 'border-red-200 bg-red-50' : 'border-violet-200 bg-violet-50'}`}>
      <div className="flex items-start gap-3">
        <div className={`h-9 w-9 rounded-full flex items-center justify-center shrink-0 ${destructive ? 'bg-red-100 text-red-600' : 'bg-violet-100 text-violet-600'}`}>
          {destructive ? <AlertTriangle className="h-4 w-4" /> : <Send className="h-4 w-4" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">{intent}</div>
          <div className="text-sm text-foreground mb-3">{description}</div>
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant={destructive ? 'destructive' : 'default'}
              onClick={() => onAction?.(intent)}
            >
              {cta}
            </Button>
            <span className="text-xs text-muted-foreground">Slug: <code>{artifact.slug}</code></span>
          </div>
        </div>
      </div>
    </div>
  );
};
